import React from "react";
import _ from "lodash";
// import styles from "./Gallery.module.scss";
import World from "../../world";
// import { mail, twitter, facebook, pinterest } from "../world/share";
import Gallery from "../../types/Gallery";
import Guest from "../../types/Guest";
import Tac from "../../types/Tac";
import Features from "../../types/Features";
import LiveHeader from "../LiveHeader";
import GalleryHeader from "../GalleryHeader";
import ThemeMenu from "../ThemeMenu";
import GalleryView from "./View";
import PicModal from "../PicModal";
import InstaTac from "../InstaTac";
import Popover from "../Popover";
import ActionLink from "../ActionLink";

export interface Props {
    world: World;
    gallery: Gallery;
    is_open: boolean;
}

// lower numbers == faster. How many ms to scroll 1 px.
const speeds = {
    fast: 4,
    medium: 8,
    slow: 16,
};

// content fitler On or OFF
const filterOn = true;

export interface State {
    tacs: Tac[];
    guests: Guest[];
    gallery: Gallery;
    is_host: boolean;
    theme_is_open: boolean;
    share_is_open: boolean;
    tour_taccing: boolean;
    tour_theme: boolean;
    tour_header: boolean;
    tour_live: boolean;
    maximized?: Tac;
    options?: string;
    insta?: Tac;
    speed: string;
}


export default class GalleryController extends React.Component<Props, State> {

    private features: Features;
    private scrollInterval: any;
    x: number;

    constructor(props: Props) {
        super(props);

        this.features = new Features();
        this.x = 0;

        const isHost = !!(
            props.world.host && 
            props.gallery.host() === props.world.host.name &&
            props.world.auth
        );

        this.state = {
            gallery: props.gallery,
            tacs: props.world.listGalleryTacs(props.gallery.name),
            guests: props.world.listGalleryGuests(props.gallery.name),
            is_host: isHost,
            theme_is_open: false,
            share_is_open: false,
            tour_taccing: false,
            tour_theme: false,
            tour_live: false,
            tour_header: false,
            speed: 'medium',
        };

        props.world.fetchAllTacs(props.gallery.name);
        props.world.fetchAllGuests(props.gallery.name);

        props.world.watch(props.gallery.name, props.gallery.access_token);

        props.world.listen(() => {
            this.setState({
                gallery: props.world.galleries[props.gallery.name],
                tacs: props.world.listGalleryTacs(props.gallery.name),
                guests: props.world.listGalleryGuests(props.gallery.name),
            });
            this.insta();
            /*
            this.tourTac();
            this.tourTheme();
            this.tourHeader();
            this.tourLive();
            this.saveTourProgress();
            */
        });
    }

    componentDidMount() {
        if (this.props.is_open) {
            this.scroll();
        }
        this.insta();
    }

    componentWillUnmount() {
        window.clearInterval(this.scrollInterval);
    }

    componentDidUpdate() {
        if (this.props.is_open) {
            this.scroll();
        }
    }


    scroll = () => {
        if (document.documentElement.clientWidth < 600) {
            return;
        }
        if (this.scrollInterval) {
            window.clearInterval(this.scrollInterval);
        }

        // Scrolling while zoomed is weird. Test before changing this.
        this.scrollInterval = setInterval(() => {
            window.scrollTo(0, this.x);
            this.x = this.x ? this.x + 1 : 1;
            if (this.x + window.innerHeight > document.body.offsetHeight) {
                this.x = 0;
            }
        }, speeds[this.state.speed])
    }

    onScrollSlow = () => {
        this.setState({speed: 'slow'});
    }

    onScrollMedium = () => {
        this.setState({speed: 'medium'});
    }

    onScrollFast = () => {
        this.setState({speed: 'fast'});
    }

    themePicker = (theme: string) => () => {
        this.props.world.updateGallery(this.props.gallery.name, {
            theme: theme,
        });
    }

    // theme menu toggle
    toggleTheme = () => {
        this.setState({
            theme_is_open: !this.state.theme_is_open,
        });
    }

    openTheme = () => {
        this.setState({
            theme_is_open: true,
        });
    }

    closeTheme = () => {
        this.setState({
            theme_is_open: false,
        });
    }
 
    toggleShare = () => {
        if (document.documentElement.clientWidth <= 420) {
            this.setState({
                share_is_open: !this.state.share_is_open,
            })
        }
    }

    showOptions = (tac?: string) => {
        this.setState({
            options: tac,
        });
    }

    maximize = (tac: Tac) => {
        this.setState({
            maximized: tac,
        });
        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                document.getElementById("pic-modal").style.opacity = "1";
            });
        });
    }

    closeModal = () => {
        document.getElementById("pic-modal").style.opacity = "0";
        setTimeout(() => {
            this.setState({
                maximized: null,
            });
        }, 400);
    }

    quarantine = (tac: Tac) => {
        if (filterOn && tac.state === "APPROVED") {
            return false;
        }
        if (!filterOn || this.state.gallery && this.state.gallery.moderation === "manual") {
            return true
        }
        return this.features.quarantine(tac);
    }

    insta() {
        if (this.state.insta) {
            return;
        }
        // mutates array, removing tacs without an image and quarantined tacs
        _.remove(this.props.world.newTacs, (name) => {
            const tac = this.props.world.tacs[name];
            
            if (tac && !tac.image) {
                return true;
            }
            // TODO in tour mode don't quarantine
            if (this.quarantine(tac)) {
                return true;
            }
        });
        const i = _.findIndex(this.props.world.newTacs, (name) => {
            const tac = this.props.world.tacs[name];

            if (tac && tac.image && tac.image.optimized) {
                return true;
            }
        });
        if (i == -1) {
            // resume tour
            this.tourTheme();
            this.tourHeader();
            this.tourLive();
            return;
        }
        const tac = this.props.world.tacs[this.props.world.newTacs[i]];

        this.props.world.newTacs.splice(i, 1);
        this.setState({
            insta: tac,
        });
        setTimeout(() => {
            this.setState({
                insta: null,
            });
            setTimeout(() => {
                this.insta();
            }, 1500);
        }, 6000);
    }

    tourTac() {
        const should = (this.state.is_host
            && !this.state.insta
            && !this.props.world.newTacs.length
            && this.props.world.host.tour
            && !this.props.world.host.has_tacced);

        this.setState({
            tour_taccing: should,
        });
    }

    tourTheme() {
        const should = (this.state.is_host
            && !this.state.insta
            && !this.props.world.newTacs.length
            && this.props.world.host.tour
            && this.props.world.host.has_tacced
            && !this.props.world.host.has_edited_theme);

        this.setState({
            tour_theme: should,
        });
    }

    tourHeader() {
        const should = (
            this.state.is_host
            && !this.state.insta
            && !this.props.world.newTacs.length
            && !this.props.is_open
            && this.props.world.host.tour
            && this.props.world.host.has_tacced
            && this.props.world.host.has_edited_theme
            && !this.props.world.host.has_edited_header
        );

        this.setState({
            tour_header: should,
        });
    }

    tourLive() {
        /*
        const should = (this.state.is_host
            && !this.state.insta
            && !this.props.world.newTacs.length
            && this.props.world.host.tour
            && this.props.is_open
            && this.props.world.host.has_tacced
            && this.props.world.host.has_edited_theme
            && !this.props.world.host.has_experienced_live);

        this.setState({
            // keep open once open except for insta
            tour_live: this.state.insta ? false : (should || this.state.tour_live),
        });
        */
    }

    saveTourProgress() {
        /*
        const hasTacced = this.state.is_host && this.state.tacs.length > 0;
        const hasEditedTheme = this.state.is_host && this.state.gallery.theme !== "classic";
        const hasEditedHeader = this.state.is_host && (!this.state.gallery.isDefaultAvatar() || !this.state.gallery.isDefaultDisplayName(this.props.world.host.full_name));
        const hasExperiencedLive = this.state.tour_live;

        if (hasTacced && !this.props.world.host.has_tacced) {
            this.props.world.updateHost(this.props.world.host.name, {
                has_tacced: true,
            });
        }

        if (hasEditedTheme && !this.props.world.host.has_edited_theme) {
            this.props.world.updateHost(this.props.world.host.name, {
                has_edited_theme: true,
            });
        }

        if (hasEditedHeader && !this.props.world.host.has_edited_header) {
            this.props.world.updateHost(this.props.world.host.name, {
                has_edited_header: true,
            });
        }

        if (hasExperiencedLive && !this.props.world.host.has_experienced_live) {
            // If still on the page in 4 seconds consider this step done
            setTimeout(() => {
                this.props.world.updateHost(this.props.world.host.name, {
                    has_experienced_live: true,
                });
            }, 4000);
        }
        */
    }

    render() {
        const fbURL = `${this.props.world.origin()}/gallery/${this.state.gallery.id()}?at=${this.state.gallery.access_token}`
        const shortURL = this.props.world.shortURL(this.props.gallery.access_token);
        const uploadURL = this.props.world.uploadURL(this.props.gallery.access_token);
        const editURL = `${this.props.world.origin()}/dashboard/galleries/${this.state.gallery.id()}/edit`;
        const queueURL = `${this.props.world.origin()}/dashboard/galleries/${this.state.gallery.id()}/tacs`;
        const themeClass = `${this.state.gallery.theme}-theme-${this.props.is_open ? "open" : "browse"}`;
        const boardClass = this.props.is_open ? "board--open" : "board";
        const classes = `${boardClass} ${themeClass} gallery`;
        const galleryItems = _.map(this.state.tacs, (tac) => {
            const guest = this.props.world.guests[tac.guest()];
            if (!guest || guest.blocked) {
                return null;
            }
            if (tac.state === "DELETED") {
                return null;
            }
            if (this.quarantine(tac)) {
                return null;
            }
            if (tac.image && !tac.image.optimized) {
                return null;
            }

            return {
                tac,
                guest,
                big: this.props.is_open,
                options: this.state.options === tac.name,
                onHideOptions: () => { this.showOptions() },
                onMaximize: () => { this.maximize(tac) },
                onMouseOver: () => { this.showOptions(tac.name) },
                onClick: () => { this.maximize(tac) },
            };
        });

        const galleryProps = {
            items: _.compact(galleryItems),
            galleryID: this.props.gallery.id(),
        };

        const galleryHeaderProps = {
            is_host: this.state.is_host,
            avatar: this.state.gallery.avatar,
            display_name: this.state.gallery.display_name,
            shareRight: this.state.share_is_open ? -6 : -66,
            onShare: this.toggleShare,
            // onMail: () => mail(this.props.gallery.display_name, shortURL),
            // onTwitter: () => twitter(shortURL),
            // onFB: () => facebook(fbURL),
            // onPinterest: () => pinterest(),
        }

        const picModalProps = {
            renditions: this.state.maximized ? this.state.maximized.image.optimized : [],
            is_host: this.state.is_host,
            onClose: this.closeModal,
            galleryID: this.state.gallery.id(),
            tacID: this.state.maximized ? this.state.maximized.id : 0,

        };

        return (
            <div className={classes}>
                {this.props.is_open ? (
                    <LiveHeader
                        avatar={this.state.gallery.avatar}
                        display_name={this.state.gallery.display_name}
                        phone={this.state.gallery.prettyPhone()} />
                ) : (
                    <GalleryHeader {...galleryHeaderProps} />
                )}

                {this.state.is_host &&
                    <ThemeMenu
                        themeOnly={this.state.tour_theme}
                        theme={this.state.gallery.theme}
                        left={this.state.theme_is_open ? 0 : -280}
                        edit_gallery_url={editURL}
                        onPick={this.themePicker}
                        onClickHamburger={this.toggleTheme}
                        onMouseEnter={this.openTheme}
                        onScrollSlow={this.onScrollSlow}
                        onScrollMedium={this.onScrollMedium}
                        onScrollFast={this.onScrollFast}
                        speed={this.state.speed}
                        canChangeSpeed={true}
                        onMouseLeave={this.closeTheme} />
                }

                <GalleryView {...galleryProps} />

                {this.state.maximized && (
                    <PicModal {...picModalProps} />
                )}

                {this.state.insta && (
                    <InstaTac tac={this.state.insta} />
                )}

                {this.state.tour_taccing && (
                    <Popover style={{animation: "ntFadeIn 1s"}}>
                        <h1>{this.state.gallery.prettyPhone()}</h1>
                        <p>Step 1: Text in a picture to your personal phone number</p>
                        <p>(wait up to 60 seconds for it to appear)</p>
                        <p style={{textAlign: "center", fontSize: "1em"}}>
                            <ActionLink secondary href={uploadURL} target="_blank">
                                (Don’t have your phone handy? Upload some pictures from your computer)
                            </ActionLink>
                        </p>
                    </Popover>
                )}

                {this.state.tour_theme && !this.state.theme_is_open && (
                    <Popover top="0px" left="60px" topLeftPointLeft>
                        <h1>Congratulations on creating your first tacs!</h1>
                        <p>Now, it’s time to personalize your gallery. Try selecting from our 17 themes.</p>
                    </Popover>
                )}

                {this.state.tour_header && !this.state.theme_is_open && (
                    <Popover top="0px" left="60px" topLeftPointLeft>
                        <h1>More Customization</h1>
                        <p>Click "Change Cover Image" to set the banner image and title to match the mood of your wedding</p>
                    </Popover>
                )}

                {this.state.tour_live && (
                    <Popover style={{animation: "ntFadeIn 1s"}}>
                        <h1>Entertain your guests with our live display!</h1>
                        <p>Stream pictures as they get texted into your gallery and project them on a screen at your reception.</p>
                        <p>Any inappropriate pictures or messages will automatically be placed in quarantine until you approve them.</p>
                        <p style={{textAlign: "center"}}>
                            <ActionLink primary href={queueURL}>
                                Visit your queue to manage quarantined images
                            </ActionLink>
                        </p>
                    </Popover>
                )}
            </div>
        );
    }
}
